import isServer from "./is-server";

export default async function fetchServerSide(path, locale, jwt = null, method = "GET") {
  const apiUrl =
    isServer() && process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
      ? process.env.NEXT_PUBLIC_SERVER_SIDE_API_URL
      : process.env.NEXT_PUBLIC_API_URL;

  const headers = {
    Language: locale,
    "X-App-Origin": "NextJs",
    "X-App-Version": process.env.HEROKU_RELEASE_VERSION,
  };

  if (jwt) {
    headers.Authorization = `Bearer ${jwt}`;
  }

  const response = await fetch(`${apiUrl}${path}`, {
    method,
    headers,
  });

  if (!response.ok) {
    throw new Error(`Network response was not ok for: ${path}, status: ${response.status}`);
  }

  return response.json();
}
